<template>
  <div id="app">
    <router-view class="router-view"></router-view>
    <loading v-model="loading"></loading>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import loading from "@/components/common/loading";
export default {
  components: {
    loading
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["loading"])
  },
  created() {
    this.setCacheData();
  },
  methods: {
    ...mapMutations(["setCacheData"])
  },
  mounted() {
    const _this = this;
    window.onscroll = function() {
      _this.$emit("pageScroll");
    };
  }
};
</script>
<style lang="scss">
@import "src/style/common";
@import "src/style/media";
@import "../node_modules/swiper/dist/css/swiper.min.css";
.router-view {
  min-height: 60vh;
}
</style>

